import { Component, OnInit } from '@angular/core';
import { NotificationLogService } from '@services/notification-log.service';
import { NotificationLogModel } from '@models/notification-log-model';
import { LocalizationService } from '@services/localization.service';
import { MatDialog } from '@angular/material';
import { NgLocaleLocalization } from '@angular/common';
import { NotificationLogPopupComponent } from './notification-log-popup/notification-log-popup.component';

@Component({
  selector: 'app-notification-log-viewer',
  templateUrl: './notification-log-viewer.component.html',
  styleUrls: ['./notification-log-viewer.component.scss']
})
export class NotificationLogViewerComponent implements OnInit {
  NotificationLogs: NotificationLogModel[];
  isLoading = true;

  constructor(
    private service: NotificationLogService,
    public localeService: LocalizationService,
    private dialog: MatDialog
  ) {}

  ngOnInit() {
    this.service.getNotificationLogs().subscribe(logs => {
      this.NotificationLogs = logs;
      this.isLoading = false;
    });
  }

  selectNotificationLog(notificationLog: NotificationLogModel) {
    const dialogRef = this.dialog.open(NotificationLogPopupComponent, {
      minWidth: '500px',
      minHeight: '400px',
      maxWidth: '80vw',
      maxHeight: '80vw',
      width: '', // clear the width.. something else is setting it
      data: {
        notificationLog,
        markRead: notificationLog.dateRead.getFullYear() === 1
      }
    });

    dialogRef.afterClosed().subscribe((returnData: string) => {
      if (returnData) {
        const parts = returnData
          .match(/(\d+)-(\d+)-(\d+)/)
          .map(x => parseInt(x, 10));
        const dateRead = new Date(parts[1], parts[2] - 1, parts[3]);
        notificationLog.dateRead = dateRead;
      }
    });
  }

  back() {
    window.history.back();
  }
}
